<template>
  <div>
    <div class="rank-container">

      <el-tabs v-model="queryList.course_type" :stretch="true">
        <el-tab-pane label="北京常规班" name="bei_jing_routine">
          <v-page-teacher-rank-list
            :date="queryList.date"
            course-type="bei_jing_routine"
            :lazy="true"
            banner="https://img.jiahewushe.com/teacher-rank/routine.png"
            title="北京地区常规班"
          />
        </el-tab-pane>
        <el-tab-pane label="非京常规班" name="other_routine">
          <v-page-teacher-rank-list
            :date="queryList.date"
            course-type="other_routine"
            :lazy="true"
            banner="https://img.jiahewushe.com/teacher-rank/other-routine.png"
            title="其他地区常规班"
          />
        </el-tab-pane>
        <el-tab-pane label="少儿班" name="child">
          <v-page-teacher-rank-list
            :date="queryList.date"
            course-type="child"
            :lazy="true"
            banner="https://img.jiahewushe.com/teacher-rank/child.png"
            title="少儿班"
          />
        </el-tab-pane>
        <el-tab-pane label="专业班" name="major">
          <v-page-teacher-rank-list
            :date="queryList.date"
            course-type="major"
            :lazy="true"
            banner="https://img.jiahewushe.com/teacher-rank/major.png"
            title="专业班"
          />
        </el-tab-pane>
      </el-tabs>

      <div class="rank-footer">
        <img src="https://img.jiahewushe.com/teacher-rank/rank-beijing-footer.png" alt=""/>
      </div>
    </div>
  </div>
</template>

<script>
  import RouteConfig from '@/router/config';
  import { mapGetters } from 'vuex';

  export default {
    name: RouteConfig.teacherRankList.name,
    data: () => ({
      count: 0,
      list: [],
      halfLength: 0,
      queryList: {
        store_id: '',
        is_asc: 0,
        page: 1,
        size: 8,
        keyword: '',
        date: '',
        course_type: 'bei_jing_routine',
      },
      isLoading: false,
    }),
    computed: {
      ...mapGetters([
        'isAdministrator',
        'isManager',
        'isReceptionist',
        'defaultStoreId',
      ]),
    },
    methods: {

    },
  };
</script>

<style scoped>
  .rank-container {
    position: relative;
    width: 100vw;
    background-image: url(https://img.jiahewushe.com/teacher-rank/rank-bg.jpg);
    background-repeat: repeat-y;
    background-size: contain;
    background-color: white;
    padding: 0 5vw;
    box-sizing: border-box;
    min-height: 100vh;
  }

  .rank-footer {
    width: 90vw;
    user-select: none;
  }

  .rank-footer img {
    width: 100%;
    display: block;
  }
</style>

